// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notebookContainer{
    color: #eee;
}

.noteCard{
    flex: 4 1;
    height: 180px;
    background-color: #282B30;
    cursor: pointer;
    overflow: hidden;
    width: 70%;
    float: left;
    padding: 10px;
    border: 1px solid #4b4e52;

}

.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{
    color: #666666 !important;
    background: #919191 !important;
    border: 1px solid #999999 !important;
  
  }

.noteCard p{
    opacity: 0.5;

}

.addNewNote{
    width: 89%;
    height: 180px;
    background-color: #282B30;
    cursor: pointer;
    padding: 12px;
    overflow: hidden;
    margin-bottom: 10px;

    display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   align-items: center;
    
}

.addNewNote button{
    font-size: 50px;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    width: 100%;
    height: 100%;
    border-radius: 0 !important;
}

.NotesortBy .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root{
    transform-origin: 0% !important;
    transform:none !important;
    transition:none !important;
    margin-left: 10px !important;
    margin-top: 7px !important;
}

.NotesortBy .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{
    transform-origin: 0% !important;
    transform:none !important;
    transition:none !important;
    margin-left: 5px !important;
}


.NotesortBy .MuiFormControl-root {
    height: 40px !important;
    color: #ccc;
    border: 1px solid #ccc;
    width: 140px;
}

.NotesortBy .MuiFormControl-root .MuiInputBase-root {
    height: 40px !important;
    color: #ccc;
    background-color: #282B30;
    font-size: 14px;
    float: right;
}
.notebookContainer .NotesortBy{
    width: 100%;
    text-align: right;
    margin-right: 20px;
}

.notebookContainer .NotesortBy .MuiFormControl-root .MuiFormLabel-root {
    color: white !important;
}

.NotesortBy .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon{
    fill: #fff !important;
}

.NotesortBy .MuiFormControl-root .MuiInputBase-root .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}


.addNewNote button:hover{
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}
.css-12rl710-MuiPaper-root-MuiDialog-paper{
    background-color: #0F0E17 !important;
}


.cardHolder{
    display: flex;
   flex-direction: row;
   flex-wrap: wrap;
   justify-content: center;
   align-items: center;
   display: flex;
   margin: 15px;

}

.noteLeft{
    width: 20%;
    float: left;
    border: 1px solid #4b4e52;
    flex: 1 1;
    height: 180px;
    padding: 10px;
    background-color: #181a1d;
}

.NoteTitle input{
    background-color: #282B30;
    width: 95%;
    height: 25px;
    color: #eee;
    padding: 5px;
    margin-bottom: 10px;
    margin-top: 10px;
}

.NoteDescription textarea{
    background-color: #282B30;
    width: 95%;
    min-height: 180px;
    color: #eee;
    padding: 5px;
    margin-bottom: 10px;
    margin-top: 5px;
}

.addNoteBookButton{
    color: #eee !important;
    border-radius: 0 !important;
    background: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%) !important;
}

.addNoteBookButton:hover{
    background: linear-gradient(90deg,rgba(37,75,119) 0%, rgba(73,150,238) 100%) !important;
}

.closeAddNoteButton{
    color: #eee !important;
    border-radius: 0 !important;
    background-color: #4b4e52 !important;

}

.closeAddNoteButton:hover{
    background-color: #696a6b !important;

}`, "",{"version":3,"sources":["webpack://./src/components/NoteBook/notebook.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,SAAO;IACP,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,aAAa;IACb,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,oCAAoC;;EAEtC;;AAEF;IACI,YAAY;;AAEhB;;AAEA;IACI,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;;IAEnB,aAAa;GACd,mBAAmB;GACnB,eAAe;GACf,uBAAuB;GACvB,mBAAmB;;AAEtB;;AAEA;IACI,eAAe;IACf,iFAAiF;IACjF,WAAW;IACX,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,+BAA+B;IAE/B,yBAAyB;IAEzB,0BAA0B;IAC1B,4BAA4B;IAC5B,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAE/B,yBAAyB;IAEzB,0BAA0B;IAC1B,2BAA2B;AAC/B;;;AAGA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;;AAGA;IACI,iFAAiF;AACrF;AACA;IACI,oCAAoC;AACxC;;;AAGA;IACI,aAAa;GACd,mBAAmB;GACnB,eAAe;GACf,uBAAuB;GACvB,mBAAmB;GACnB,aAAa;GACb,YAAY;;AAEf;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,SAAO;IACP,aAAa;IACb,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,wFAAwF;AAC5F;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,oCAAoC;;AAExC;;AAEA;IACI,oCAAoC;;AAExC","sourcesContent":[".notebookContainer{\n    color: #eee;\n}\n\n.noteCard{\n    flex: 4;\n    height: 180px;\n    background-color: #282B30;\n    cursor: pointer;\n    overflow: hidden;\n    width: 70%;\n    float: left;\n    padding: 10px;\n    border: 1px solid #4b4e52;\n\n}\n\n.css-sghohy-MuiButtonBase-root-MuiButton-root.Mui-disabled{\n    color: #666666 !important;\n    background: #919191 !important;\n    border: 1px solid #999999 !important;\n  \n  }\n\n.noteCard p{\n    opacity: 0.5;\n\n}\n\n.addNewNote{\n    width: 89%;\n    height: 180px;\n    background-color: #282B30;\n    cursor: pointer;\n    padding: 12px;\n    overflow: hidden;\n    margin-bottom: 10px;\n\n    display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: center;\n   align-items: center;\n    \n}\n\n.addNewNote button{\n    font-size: 50px;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    width: 100%;\n    height: 100%;\n    border-radius: 0 !important;\n}\n\n.NotesortBy .css-1jy569b-MuiFormLabel-root-MuiInputLabel-root{\n    transform-origin: 0% !important;\n    -webkit-transform: none !important;\n    transform:none !important;\n    -webkit-transition:none !important;\n    transition:none !important;\n    margin-left: 10px !important;\n    margin-top: 7px !important;\n}\n\n.NotesortBy .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root{\n    transform-origin: 0% !important;\n    -webkit-transform: none !important;\n    transform:none !important;\n    -webkit-transition:none !important;\n    transition:none !important;\n    margin-left: 5px !important;\n}\n\n\n.NotesortBy .MuiFormControl-root {\n    height: 40px !important;\n    color: #ccc;\n    border: 1px solid #ccc;\n    width: 140px;\n}\n\n.NotesortBy .MuiFormControl-root .MuiInputBase-root {\n    height: 40px !important;\n    color: #ccc;\n    background-color: #282B30;\n    font-size: 14px;\n    float: right;\n}\n.notebookContainer .NotesortBy{\n    width: 100%;\n    text-align: right;\n    margin-right: 20px;\n}\n\n.notebookContainer .NotesortBy .MuiFormControl-root .MuiFormLabel-root {\n    color: white !important;\n}\n\n.NotesortBy .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon{\n    fill: #fff !important;\n}\n\n.NotesortBy .MuiFormControl-root .MuiInputBase-root .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n\n\n.addNewNote button:hover{\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n.css-12rl710-MuiPaper-root-MuiDialog-paper{\n    background-color: #0F0E17 !important;\n}\n\n\n.cardHolder{\n    display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   justify-content: center;\n   align-items: center;\n   display: flex;\n   margin: 15px;\n\n}\n\n.noteLeft{\n    width: 20%;\n    float: left;\n    border: 1px solid #4b4e52;\n    flex: 1;\n    height: 180px;\n    padding: 10px;\n    background-color: #181a1d;\n}\n\n.NoteTitle input{\n    background-color: #282B30;\n    width: 95%;\n    height: 25px;\n    color: #eee;\n    padding: 5px;\n    margin-bottom: 10px;\n    margin-top: 10px;\n}\n\n.NoteDescription textarea{\n    background-color: #282B30;\n    width: 95%;\n    min-height: 180px;\n    color: #eee;\n    padding: 5px;\n    margin-bottom: 10px;\n    margin-top: 5px;\n}\n\n.addNoteBookButton{\n    color: #eee !important;\n    border-radius: 0 !important;\n    background: linear-gradient(90deg, rgba(73,150,238) 0%, rgba(37,75,119) 100%) !important;\n}\n\n.addNoteBookButton:hover{\n    background: linear-gradient(90deg,rgba(37,75,119) 0%, rgba(73,150,238) 100%) !important;\n}\n\n.closeAddNoteButton{\n    color: #eee !important;\n    border-radius: 0 !important;\n    background-color: #4b4e52 !important;\n\n}\n\n.closeAddNoteButton:hover{\n    background-color: #696a6b !important;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
